export default __webpack_public_path__ + "static/media/undraw_Success_factors_re_ce93.d7765b61.svg";